// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2HjyF","title":"Header_title__3wR30","side":"Header_side__2RuWX"};